import { min, max } from 'd3-array';

import Indicator from '../Indicator';

/** Bollinger Band Width indicator */
export default class BollingerBandWidthIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} dataSeries - Indicator data series
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 */
	_getDefaultParams() {
		return {
			id: 'bollingerbandwidth',
			name: 'Bollinger Band Width',
			dataSeries: 'bandwidth',
			description: 'The Bollinger Band Width indicator measures the difference between the upper and lower Bollinger Bands, providing insights into market volatility by showing how widely or narrowly the bands are spread.',
			inputs: [
				{ name: 'period', value: 20 },
				{ name: 'standardDeviations', value: 2, max: 10 }
			],
			componentSeries: [
				{ id: 'bandwidth' }
			]
		};
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range minimum
	 */
	getRangeMin(data) {
		return min(data.bollingerbandwidth, i => +i.bandwidth);
	}

	/**
	 * @param {object} data - Symbol data object
	 * @return {number} - d3-range maximum
	 */
	getRangeMax(data) {
		return max(data.bollingerbandwidth, i => +i.bandwidth);
	}

	/** @param {object} data - Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data.bollingerbandwidth,
			dataKey: 'bandwidth',
			sessionType,
			marker: this.markers.line
		});
	}
}
